import React from 'react';
import '../css/Distinctions.css';

export default class Distrinctions extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
    }
    getLink(distinction){
        if(distinction.link_type=="none"){
            return;
        }else if(distinction.link_type=="project"){
            return <a href="#" className="distinction__link"></a>
        }else{
            return <a className="distinction__link" href={distinction.external_link} target="_blank"></a>
        }
    }
    distinctionContent(distinction){
        return(
            <div className="distinction__content">
                <span className="distinction__date">
                    {distinction.date}
                </span>
                <span className="distinction__title">
                    {distinction.title}
                </span>
            </div>
        )
    }
    goToProject(evt, distinction){
        if (evt.preventDefault) evt.preventDefault();
        this.props.history.push(distinction.linked_project);
        return false;
    }
    distinctionItem(distinction, index){
        if(distinction.link_type=="none"){
            return <div key={index} className="distinction">{this.distinctionContent(distinction)}</div>
        }else if(distinction.link_type=="project"){
            return <a key={index} href={distinction.linked_project} onClick={(evt)=>{this.goToProject(evt,distinction)}}className="distinction">{this.distinctionContent(distinction)}</a>
        }else{
            return <a key={index} className="distinction" href={distinction.external_link} target="_blank">{this.distinctionContent(distinction)}</a>
        }
    }
    render(){
        const {distinctions} = this.props;
        return(
            <div className="distinctions">
                <strong className="distinctions__title">Distinctions</strong>
                {distinctions.map((distinction, index) => (
                    this.distinctionItem(distinction, index)
                ))}
              </div>
        )
    }

}